module.exports = __webpack_public_path__ + "slide2.3ffa013570c3021c6650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide2.jpg
// module id = ./src/assets/images/private/home/slide2.jpg
// module chunks = main